/* eslint-disable arrow-parens */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { VEBPlanSchema } from "../../types/VEBPlanSchema";
import { getActiveVEBPlans } from "../../utils/api/pages/VEBPlaniInit";

export const vebPlansApi = createApi({
	reducerPath: "vebPlansApi",
	baseQuery: fetchBaseQuery({ baseUrl: "/api" }),
	tagTypes: ["VEBPlan"], // tag for auto-refetch if you ever invalidate
	endpoints: (builder) => ({
		getActiveVEBPlans: builder.query<
			{ currentPlans: VEBPlanSchema[]; futurePlans: VEBPlanSchema[] },
			number | string
		>({
			// Using queryFn to call existing async function
			async queryFn(group_number) {
				try {
					if (!group_number) throw new Error("group_number is required");

					const data = await getActiveVEBPlans(group_number);
					// Ensure data always has arrays
					return {
						data: {
							currentPlans: data.currentPlans || [],
							futurePlans: data.futurePlans || []
						}
					};
				} catch (err: any) {
					console.error("Error fetching active VEB plans:", err);
					return { error: { status: "CUSTOM_ERROR", error: err.message || "Failed to fetch plans" } };
				}
			},
			providesTags: ["VEBPlan"]
		})
	})
});

export const { useGetActiveVEBPlansQuery } = vebPlansApi;
